module.exports = __webpack_public_path__ + "img/access_restriction.734aa978.png";